import React from "react";

export default function Pagination({
  currentPage,
  totalPages,
  totalEntries,
  limit,
  onPageChange,
  onLimitChange,
  limitOptions = [10, 25, 50, 100],
}) {
  const safeTotalPages = totalPages || 1;
  const startIndex = totalEntries === 0 ? 0 : (currentPage - 1) * limit + 1;
  const endIndex = Math.min(currentPage * limit, totalEntries);

  // Generate page numbers array with max 5 items + dots
  const getPageNumbers = () => {
    const pages = [];

    if (safeTotalPages <= 5) {
      for (let i = 1; i <= safeTotalPages; i++) pages.push(i);
    } else {
      pages.push(1);

      if (currentPage > 3) {
        pages.push("...");
      }

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(safeTotalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) pages.push(i);
      }

      if (currentPage < safeTotalPages - 2) {
        pages.push("...");
      }

      if (!pages.includes(safeTotalPages)) {
        pages.push(safeTotalPages);
      }
    }

    return pages;
  };

  return (
    <div className="table-pagination-footer flex flex-wrap items-center justify-between gap-3 p-3 bg-white border-t border-gray-100 text-xs">
      {/* Left: Entries Info & Limit Dropdown */}
      <div className="flex items-center gap-4">
        <span className="text-gray-500 font-medium">
          Showing{" "}
          <span className="text-gray-800 font-semibold">
            {startIndex}-{endIndex}
          </span>{" "}
          of{" "}
          <span className="text-gray-800 font-semibold">{totalEntries}</span>{" "}
          Entries
        </span>

        <div className="relative">
          <select
            value={limit}
            onChange={(e) => {
              onLimitChange(Number(e.target.value));
              onPageChange(1); // Reset to page 1 on limit change
            }}
            className="pagination-dropdown"
          >
            {limitOptions.map((option) => (
              <option key={option} value={option}>
                Show {option}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Right: Pill Controls */}
      <div className="flex items-center gap-1.5">
        <button
          className="pagination-pill-btn"
          disabled={currentPage === 1}
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
        >
          Prev
        </button>

        {getPageNumbers().map((item, index) => {
          if (item === "...") {
            return (
              <span
                key={`dots-${index}`}
                className="px-1 text-gray-400 font-bold"
              >
                ...
              </span>
            );
          }

          return (
            <button
              key={item}
              onClick={() => onPageChange(item)}
              className={`pagination-num-btn ${
                currentPage === item ? "active" : ""
              }`}
            >
              {item}
            </button>
          );
        })}

        <button
          className="pagination-pill-btn"
          disabled={currentPage === safeTotalPages || safeTotalPages === 0}
          onClick={() => onPageChange(Math.min(currentPage + 1, safeTotalPages))}
        >
          Next
        </button>
      </div>
    </div>
  );
}